// extracted by mini-css-extract-plugin
export default {"modal":"UampK","mobile":"p83Ox","modalContent":"hqAWE","header":"SnVYG","subtitle":"_8YCh8","content":"Bqrr+","buttonContainer":"pv6CW","button":"_6nDuu"};